export const MARKETING_CONTACT = {
  email: "admin@silick.com",
  phoneDisplay: "+234 812 172 6649",
  phoneTel: "+2348121726649",
} as const;

export const FEATURE_ITEMS = [
  {
    key: "catalog",
    title: "Catalog Management",
    description:
      "Organize and manage your entire collection with advanced cataloging tools and digital resource support.",
  },
  {
    key: "circulation",
    title: "Circulation Control",
    description:
      "Track checkouts, returns, reservations, and fines with automated workflows and notifications.",
  },
  {
    key: "multi-tenant",
    title: "Multi-Tenant Architecture",
    description:
      "Complete data isolation for universities, public libraries, and institutions on a single platform.",
  },
  {
    key: "performance",
    title: "Fast & Reliable",
    description:
      "Built for performance with modern technologies ensuring quick response times and uptime.",
  },
  {
    key: "locale",
    title: "Multi-Language Support",
    description: "Support multiple languages and locales to serve diverse communities effectively.",
  },
  {
    key: "roles",
    title: "Role-Based Access",
    description:
      "Granular permissions for admins, librarians, and patrons with customizable roles and access levels.",
  },
] as const;

export const AUDIENCE_ITEMS = [
  {
    title: "Universities & Colleges",
    description:
      "Multi-branch campuses, staff roles, patron registration, and academic workflows in one system.",
  },
  {
    title: "Public Libraries",
    description:
      "Serve communities with circulation, holds, fines, and self-service registration from any branch.",
  },
  {
    title: "Schools & Institutes",
    description:
      "Lightweight setup for school libraries that need catalog control without a heavy IT project.",
  },
] as const;

export const HOW_IT_WORKS_STEPS = [
  {
    step: "1",
    title: "Create your library",
    description: "Sign up and claim your subdomain in minutes, with no servers to install.",
  },
  {
    step: "2",
    title: "Brand & configure",
    description: "Set branding, policies, patron types, locations, and registration rules.",
  },
  {
    step: "3",
    title: "Invite your team",
    description: "Add staff, open for patrons, and start circulating with modern tools.",
  },
] as const;

export const MODULE_ITEMS = [
  {
    title: "Catalog & digital resources",
    description: "ISBN and manual cataloging, journals, e-resources, and public viewing.",
  },
  {
    title: "Circulation desk",
    description: "Checkouts, returns, holds, overdue tracking, and fine management.",
  },
  {
    title: "Acquisitions",
    description: "Vendors, funds, purchase orders, receiving, and patron recommendations.",
  },
  {
    title: "Branches & transfers",
    description: "Multi-branch inventory, staff permissions, and inter-branch transfers.",
  },
  {
    title: "Bindery & thesis",
    description: "Bindery workflows and thesis request handling for academic libraries.",
  },
  {
    title: "Billing & onboarding",
    description: "Self-serve tenant onboarding, library cards, invoices, and subscription billing.",
  },
] as const;

export const WHY_ITEMS = [
  {
    title: "True multi-tenant SaaS",
    description:
      "Each library gets isolated data and its own subdomain, without maintaining separate installs.",
  },
  {
    title: "Go live without an IT project",
    description:
      "Skip server setup and long implementations. Start with self-serve onboarding and modern UI.",
  },
  {
    title: "Built for institutions that need support",
    description:
      "Talk directly with the PhiloLMS team for demos, onboarding help, and operational questions.",
  },
] as const;

export const COMPARISON_ROWS = [
  {
    label: "Delivery model",
    philolms: "Cloud SaaS",
    koha: "Open source (self-host or hosted)",
    evergreen: "Open source (self-host or consortia)",
    alma: "Enterprise cloud (vendor-hosted)",
  },
  {
    label: "Typical setup",
    philolms: "Self-serve in minutes",
    koha: "Implementation project",
    evergreen: "Implementation project",
    alma: "Enterprise rollout",
  },
  {
    label: "Best fit",
    philolms: "Schools, universities, growing libraries",
    koha: "Libraries with technical capacity",
    evergreen: "Public / consortial systems",
    alma: "Large research universities",
  },
  {
    label: "Multi-library SaaS",
    philolms: "Native multi-tenant",
    koha: "Per installation",
    evergreen: "Consortia-oriented",
    alma: "Institution / network contracts",
  },
  {
    label: "Ops burden",
    philolms: "Vendor-managed platform",
    koha: "You or a host manage it",
    evergreen: "You or a consortium manage it",
    alma: "Vendor + institutional IT",
  },
] as const;
